jQuery(document).ready(function () {
  jQuery('a[href^="http"]')
    .not('a[href^="' + $(location).attr('hostname') + '"]')
    .attr('target', '_blank');

  jQuery('.accordion .acc-item .acc-title').click(function () {
    jQuery(this).parent().toggleClass('active');
    jQuery(this).parent().find('.acc-content').slideToggle('fast');
  });

  jQuery('.productgrid--item .productitem .modal-btn').click(function () {
    var modalImg = jQuery(this).attr('attr-link');
    jQuery('body').css('overflow', 'hidden');

    if (modalImg != '') {
      jQuery('.terpene-overlay .terpene-content .terpene-img').attr(
        'src',
        modalImg
      );

      jQuery('.terpene-overlay .terpene-content .terpene-img').show();
      jQuery('.terpene-overlay').fadeIn('fast');
    } else {
      jQuery('.terpene-overlay .terpene-content .terpene-img').hide();
      jQuery('.terpene-overlay').fadeIn('fast');
      jQuery('.terpene-overlay .terpene-content .error-message').fadeIn();
    }
  });

  jQuery('.template-product .prod-extra-info .modal-btn').click(function () {
    var modalImg = jQuery(this).attr('attr-link');
    jQuery('body').css('overflow', 'hidden');

    if (modalImg != '') {
      jQuery('.terpene-overlay .terpene-content .terpene-img').attr(
        'src',
        modalImg
      );

      jQuery('.terpene-overlay .terpene-content .terpene-img').show();
      jQuery('.terpene-overlay').fadeIn('fast');
    } else {
      jQuery('.terpene-overlay .terpene-content .terpene-img').hide();
      jQuery('.terpene-overlay').fadeIn('fast');
      jQuery('.terpene-overlay .terpene-content .error-message').fadeIn();
    }
  });

  jQuery('.terpene-overlay .terpene-content .close-btn').click(function () {
    jQuery('body').css('overflow', 'auto');

    jQuery('.terpene-overlay .terpene-content .terpene-img').hide('fast');
    jQuery('.terpene-overlay .terpene-content .error-message').hide('fast');
    jQuery('.terpene-overlay').hide();
  });

  jQuery(document).on(
    'click',
    '.template-page.inventory-by-locationv2 .productgrid--item.modal-popup',
    function () {
      var modal_image = jQuery(this)
        .find('.product-modal-details')
        .attr('data-image-high');
      var modal_image_thumbnail = jQuery(this)
        .find('.product-modal-details')
        .attr('data-image-low');
      var modal_title = jQuery(this)
        .find('.product-modal-details')
        .attr('data-title');
      var modal_vendor = jQuery(this)
        .find('.product-modal-details')
        .attr('data-vendor');
      var modal_title = jQuery(this)
        .find('.product-modal-details')
        .attr('data-title');

      var modal_thc = jQuery(this)
        .find('.product-modal-details .property-thc')
        .text();
      var modal_cbd = jQuery(this)
        .find('.product-modal-details .property-cbd')
        .text();
      var modal_gene = jQuery(this)
        .find('.product-modal-details .property-gene')
        .text();

      var modal_description = jQuery(this)
        .find('.product-modal-details .rte')
        .html();

      jQuery(
        '.template-page.inventory-by-locationv2 .modal-overlay .modal-main-content .modal-box_image img'
      )
        .attr('src', modal_image)
        .css('visibility', 'visible');
      jQuery(
        '.template-page.inventory-by-locationv2 .modal-overlay .modal-main-content .thumbnails-wrapper-custom img'
      ).attr('src', modal_image_thumbnail);
      jQuery(
        '.template-page.inventory-by-locationv2 .modal-overlay .modal-main-content .modal-prod-desc h2'
      ).text(modal_title);
      jQuery(
        '.template-page.inventory-by-locationv2 .modal-overlay .modal-main-content .modal-prod-desc .prod_vendor'
      ).text(modal_vendor);

      jQuery(
        '.template-page.inventory-by-locationv2 .modal-overlay .modal-main-content .modal-prod-desc .thc-item span'
      ).text(modal_thc);
      jQuery(
        '.template-page.inventory-by-locationv2 .modal-overlay .modal-main-content .modal-prod-desc .cbd-item span'
      ).text(modal_cbd);
      jQuery(
        '.template-page.inventory-by-locationv2 .modal-overlay .modal-main-content .modal-prod-desc .gen-item span'
      ).text(modal_gene);

      jQuery(
        '.template-page.inventory-by-locationv2 .modal-overlay .modal-main-content .modal-prod-desc .prod_description'
      ).html(modal_description);

      jQuery('.template-page.inventory-by-locationv2 .modal-overlay').fadeIn(
        'fast',
        function () {
          jQuery('body').css('overflow', 'hidden');
        }
      );
    }
  );

  jQuery(document).on(
    'click',
    '.template-page.inventory-by-locationv2 .modal-overlay .close-btn',
    function () {
      jQuery('body').css('overflow', 'auto');
      jQuery('.template-page.inventory-by-locationv2 .modal-overlay').hide();

      jQuery(
        '.template-page.inventory-by-locationv2 .modal-overlay .modal-main-content .modal-box_image img'
      ).css('visibility', 'hidden');
    }
  );

  // age popup codes

  if (
    window.location.href.indexOf('pages/terms-and-conditions') < 0 &&
    window.location.href.indexOf('pages/privacy-policy') < 0 &&
    jQuery('.template-page').hasClass('inventory-by-location-staff') == false
  ) {
    if (
      Cookies.get('verifiedage_1day') == undefined &&
      Cookies.get('verifiedage_30day') == undefined
    ) {
      jQuery('.age-verification-overlay').fadeIn(function () {
        jQuery('body').css('overflow', 'hidden');
      });

      var minOffset = 0,
        maxOffset = 100;
      var thisYear = new Date().getFullYear();

      for (var i = minOffset; i <= maxOffset; i++) {
        var year = thisYear - i;
        $('<li>', { value: year, text: year }).appendTo(
          '.age-verification-overlay .field-container #year'
        );
      }
    }
  }

  // show picker on field focus
  jQuery('.age-verification-overlay .field-container input').on(
    'focus',
    function () {
      jQuery(this).parent().find('.picker').fadeIn('medium');
    }
  );

  jQuery('.age-verification-overlay .field-container input').on(
    'blur',
    function () {
      jQuery(this).parent().find('.picker').fadeOut('medium');
    }
  );

  // picker functionality to set value on the text field
  jQuery('.age-verification-overlay .field-container ul li').click(function () {
    var picker_val = jQuery(this).attr('value');

    jQuery(this).closest('.field-container').find('input').val(picker_val);

    jQuery(this).parent().find('li').removeClass('selected');
    jQuery(this).addClass('selected');

    console.log(picker_val);
  });

  // function to calculate age based on birthdate
  function getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  jQuery('.age-verification-overlay .btn-submit').click(function (e) {
    var currentYear = parseInt(
      jQuery('.age-verification-overlay .form-container').attr('att-year')
    );
    var txtMonth = parseInt(
      jQuery(
        ".age-verification-overlay .birth-date input[name='txt_month']"
      ).val()
    );
    var txtDay = parseInt(
      jQuery(
        ".age-verification-overlay .birth-date input[name='txt_day']"
      ).val()
    );
    var txtYear = parseInt(
      jQuery(
        ".age-verification-overlay .birth-date input[name='txt_year']"
      ).val()
    );
    var txtYearMin = parseInt(
      jQuery(
        ".age-verification-overlay .birth-date input[name='txt_year']"
      ).attr('min')
    );
    var txtYearMax = parseInt(
      jQuery(
        ".age-verification-overlay .birth-date input[name='txt_year']"
      ).attr('max')
    );
    var selProvince = jQuery('.age-verification-overlay .sel-province').val();
    var selProvinceAge = parseInt(
      jQuery('.age-verification-overlay .sel-province option:selected').attr(
        'attr-age'
      )
    );
    var isValidMonth,
      isValidDay,
      isValidYear,
      isValidProvince = false;

    if (isNaN(txtMonth) || txtMonth > 12) {
      jQuery(".age-verification-overlay .birth-date input[name='txt_month']")
        .css('border-color', '#fb7f7f')
        .focus();
      console.log('error1');
    } else {
      jQuery(
        ".age-verification-overlay .birth-date input[name='txt_month']"
      ).css('border-color', '#ddd');
      var isValidMonth = true;
    }

    if (!isNaN(txtDay) && txtDay < 31) {
      jQuery(".age-verification-overlay .birth-date input[name='txt_day']").css(
        'border-color',
        '#ddd'
      );

      if (txtMonth == 2 && txtDay > 28) {
        jQuery(".age-verification-overlay .birth-date input[name='txt_month']")
          .css('border-color', '#fb7f7f')
          .focus();
        jQuery(".age-verification-overlay .birth-date input[name='txt_day']")
          .css('border-color', '#fb7f7f')
          .focus();
      } else {
        jQuery(
          ".age-verification-overlay .birth-date input[name='txt_month']"
        ).css('border-color', '#ddd');
        jQuery(
          ".age-verification-overlay .birth-date input[name='txt_day']"
        ).css('border-color', '#ddd');
        var isValidDay = true;
      }
    } else {
      jQuery(".age-verification-overlay .birth-date input[name='txt_day']")
        .css('border-color', '#fb7f7f')
        .focus();
      var isValidDay = true;
    }

    if (isNaN(txtYear) || txtYear > txtYearMax || txtYear < txtYearMin) {
      jQuery(".age-verification-overlay .birth-date input[name='txt_year']")
        .css('border-color', '#fb7f7f')
        .focus();
    } else {
      jQuery(
        ".age-verification-overlay .birth-date input[name='txt_year']"
      ).css('border-color', '#ddd');
      var isValidYear = true;
    }

    if (selProvince == null) {
      jQuery('.age-verification-overlay .sel-province')
        .css('border-color', '#fb7f7f')
        .focus();
    } else {
      jQuery('.age-verification-overlay .sel-province').css(
        'border-color',
        '#ddd'
      );
      var isValidProvince = true;
    }

    if (isValidMonth && isValidDay && isValidYear && isValidProvince) {
      var currentAge = parseInt(
        getAge(txtYear + '/' + txtMonth + '/' + txtDay)
      );

      if (currentAge < selProvinceAge) {
        jQuery('.age-verification-overlay .error-message').slideDown(
          'fast',
          function () {
            jQuery('.age-verification-overlay .error-message')
              .delay(4000)
              .fadeOut();
          }
        );
      } else {
        var isChecked = $('input[name="rad_remember"]:checked').length;

        if (isChecked == 1) {
          if (Cookies.get('verifiedage_30day') == undefined) {
            //the 0.001 is equivalent to 2mins, 1 = 1day
            Cookies.set('verifiedage_30day', 'default', { expires: 30 });
          }
        } else {
          if (Cookies.get('verifiedage_1day') == undefined) {
            //the 0.001 is equivalent to 2mins, 1 = 1day
            Cookies.set('verifiedage_1day', 'default', { expires: 1 });
          }
        }

        jQuery('body').css('overflow', 'auto');
        jQuery('.age-verification-overlay').fadeOut(function () {
          // DISABLED this reload for Local Pickup and Delivery (OCT 2020)
          // if (jQuery('.template-article').hasClass('store-location')) {
          //   location.reload();
          // }
        });
      }
    }

    // jQuery('body').css('overflow','auto');
    // jQuery(".template-index .age-verification-overlay").fadeOut();
  });

  /*
  var md = new MobileDetect(window.navigator.userAgent);
  if (md.mobile()) {
    jQuery('#edit_birthdate')
      .mobiscroll()
      .date({
        theme: 'mobiscroll-dark',
        display: 'bottom',
        startYear: new Date().getFullYear() - 120,
        endYear: new Date().getFullYear(),
        onSelect: function (valueText, inst) {
          var date = inst.getVal();
          var birthDay = date.getDate();
          var birthMonth = date.getMonth() + 1;
          var birthYear = date.getFullYear();
          jQuery('#edit_birthday').val(birthDay);
          jQuery('#edit_birthmonth').val(birthMonth);
          jQuery('#edit_birthyear').val(birthYear);
        },
      });
  }
  */
  // cart page age verification

  if (window.location.href.indexOf('cart') > 0) {
    var minOffset = 10,
      maxOffset = 100;
    var thisYear = new Date().getFullYear();

    for (var i = minOffset; i <= maxOffset; i++) {
      var year = thisYear - i;
      $('<option>', { value: year, text: year, defaultSelected: year == "2000" ? true : false, selected: year == "2000" ? true : false}).appendTo(
        '.cart-age-verification .form-fields #year'
      );
    }

    jQuery(".template-cart form button[name='checkout']").click(function (e) {
      var validAge = parseInt(
        jQuery('.cart-age-verification .form-fields').attr('data-valid-age')
      );
      var txtMonth = parseInt(
        jQuery('.cart-age-verification .form-fields #month').val()
      );
      var txtDay = parseInt(
        jQuery('.cart-age-verification .form-fields #day').val()
      );
      var txtYear = parseInt(
        jQuery('.cart-age-verification .form-fields #year').val()
      );

      var currentAge = parseInt(
        getAge(txtYear + '/' + txtMonth + '/' + txtDay)
      );
      console.log(currentAge);

      // aggreement attribute
      var agreementCheckBox = jQuery(
        '.cart-attribute__field #agreement:checked'
      );

      if (currentAge < validAge) {
        e.preventDefault();

        jQuery('html, body').animate(
          {
            scrollTop:
              jQuery(jQuery('.cart-age-verification')).offset().top - 100,
          },
          300
        );

        jQuery('.cart-age-verification .error-msg').fadeIn('fast', function () {
          jQuery('.cart-age-verification .error-msg').delay(4000).fadeOut();
        });
      } else if (agreementCheckBox.length < 1) {
        console.log('checkbox unchecked');

        jQuery('.cart-attribute__field #agreement').css(
          'border',
          'red solid 1px'
        );

        jQuery('html, body').animate(
          {
            scrollTop:
              jQuery(jQuery('.cart-age-verification')).offset().top - 100,
          },
          300
        );
      }
    });
  }

  //  simple store location list search

  // jQuery(".panel-container .txt-search").keyup(function() {
  // 	var value = jQuery(this).val().toLowerCase();

  // 	jQuery(".panel-container .panel-data").find(".data-item").each(function(index) {
  // 		var id = jQuery(this).find("h2").text().toLowerCase() + ' ' + jQuery(this).find(".icon-marker").text().toLowerCase();
  // 		jQuery(this).toggle(id.indexOf(value) !== -1);
  // 	});
  // });

  // map initialization code

  var defLat = parseFloat(
    jQuery('.panel-container .panel-data').attr('data-defLat')
  );
  var defLong = parseFloat(
    jQuery('.panel-container .panel-data').attr('data-defLang')
  );

  // default position of the map
  var center = { lat: defLat, lng: defLong };

  // zoom value
  var zoom = parseInt(
    jQuery('.panel-container .panel-data').attr('data-zoomlvl')
  );

  // // list of locations
  // var locations = [
  //   {% for block in section.blocks %}
  //     {% if block.settings.location_lat and block.settings.location_long %}
  //       [ {{ block.settings.location_lat }} , {{ block.settings.location_long }}, {{ forloop.index }},
  //       "<p><strong>{{ block.settings.location_name }}</strong></p><p>{{ block.settings.location_address }}</p><a href='tel:{{ block.settings.location_tel }}'>{{ block.settings.location_tel }} </a>--<a href='tel:{{ block.settings.location_email }}'> {{ block.settings.location_email }}</a>" ],
  //     {% endif %}
  //   {% endfor %}
  // ];

  function initMap() {
    //  custom style for the map -- this style if gray scheme
    var styles = [
      {
        elementType: 'geometry',
        stylers: [
          {
            color: '#f5f5f5',
          },
        ],
      },
      {
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#616161',
          },
        ],
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#f5f5f5',
          },
        ],
      },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#bdbdbd',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
          {
            color: '#eeeeee',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#757575',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
          {
            color: '#e5e5e5',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#9e9e9e',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [
          {
            color: '#ffffff',
          },
        ],
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#757575',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [
          {
            color: '#dadada',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#616161',
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#9e9e9e',
          },
        ],
      },
      {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [
          {
            color: '#e5e5e5',
          },
        ],
      },
      {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [
          {
            color: '#eeeeee',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          {
            color: '#c9c9c9',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#9e9e9e',
          },
        ],
      },
    ];

    gmarkers = [];

    // map initialization
    var map = new google.maps.Map(document.getElementById('map-canvas'), {
      center: center,
      zoom: 16,
      scrollwheel: false,
      styles: styles,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
    });

    var infowindow = new google.maps.InfoWindow();

    // Create the search box.
    var input = document.getElementById('text_search');
    var searchBox = new google.maps.places.SearchBox(input);

    // Bias the SearchBox results towards current map's viewport.
    map.addListener('bounds_changed', function () {
      searchBox.setBounds(map.getBounds());
    });

    // marker creation function
    function createMarker(latlng, html) {
      var marker = new google.maps.Marker({
        position: latlng,
        map: map,
        icon:
          '//cdn.shopify.com/s/files/1/0090/6438/2521/t/3/assets/map-pin.png',
      });

      google.maps.event.addListener(marker, 'click', function () {
        infowindow.setContent(html);
        infowindow.open(map, marker);

        //  uncomment if you want to make map centered every click
        map.setCenter(marker.getPosition());
      });
      return marker;
    }

    //  code to loop the locations and add individual marker via createMarker function
    // for (var i = 0; i < locations.length; i++) {
    //     gmarkers[locations[i][2]] =
    //     createMarker(new google.maps.LatLng(locations[i][0], locations[i][1]), locations[i][3]);
    // }

    jQuery('.panel-container .panel-data .data-item').each(function (index) {
      index++;

      var dataLat = parseFloat(jQuery(this).attr('data-lat'));
      var dataLong = parseFloat(jQuery(this).attr('data-long'));

      var dataName = jQuery(this).attr('data-name');
      var dataAddress = jQuery(this).attr('data-address');
      var dataTel = jQuery(this).attr('data-tel');
      var dataEmail = jQuery(this).attr('data-email');
      var dataHours = jQuery(this).attr('data-hours');
      var newAddress = dataName + ' ' + dataAddress;

      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: newAddress }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          dataLat = parseFloat(results[0].geometry.location.lat());
          dataLong = parseFloat(results[0].geometry.location.lng());
        }

        var dataInfo =
          '<p><strong>' +
          dataName +
          '</strong></p><p>' +
          dataAddress +
          '</p><p>' +
          dataHours +
          "</p><a href='tel:" +
          dataTel +
          "'>" +
          dataTel +
          "</a>--<a href='mailto:" +
          dataEmail +
          "'>" +
          dataEmail +
          '</a>';

        gmarkers[index] = createMarker(
          new google.maps.LatLng(dataLat, dataLong),
          dataInfo
        );
        var center = new google.maps.LatLng(dataLat, dataLong);
        // using global variable:
        map.panTo(center);
      });
    });
  }

  if (jQuery('.map-wrapper #map-canvas').length) {
    initMap();
  }

  if ($(window).width() < 767) {
    if (jQuery('.map-wrapper #map-canvas').length) {
      initMap();
    }
  }

  jQuery(document).on('shopify:section:load', function () {
    if (jQuery('.map-wrapper #map-canvas').length) {
      initMap();
    }
  });

  /*
  -- STORE/PROVINCE SELECTOR (OCT 2020)
  */
  (function () {
    const STOREFRONT_ACCESS_TOKEN =
      location.host === 'www.delta9.ca'
        ? 'e9481db5cdd2b5c05e20a2304f0d4ba5'
        : '615aae044380e4bba265745277b43b12';
    const storefrontHeaders = new Headers({
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': `${STOREFRONT_ACCESS_TOKEN}`,
    });

    let cart = {};
    let selectedStore;
    const savedStore = Cookies.get('store_pref');
    const validStores = [
      'brandon',
      'kenaston',
      'kildonancrossing',
      'online',
      'river',
      'stvital',
      'thompson',
    ];

    const getCart = async () => {
      try {
        const result = await $.ajax({
          url: '/cart.js',
          dataType: 'json',
        });

        return result;
      } catch (error) {
        console.error(error);
      }
    };

    const initSelectStore = async () => {
      cart = await getCart();
      // get store saved in cart
      selectedStore = cart.attributes.store;
      // if age gate open, then have to open store modal when it is hidden again
      const isAgeGateOpen =
        $('.age-verification-overlay').css('display') === 'block';

      if (
        (selectedStore && validStores.includes(selectedStore)) ||
        isAgeGateOpen
      ) {
        return;
      }

      // open store picker modal if no valid store has been selected
      openStorePickerModal();
    };

    const $storePickerLink = $('.store-picker-link');
    const $selectStoreLink = $('.select-store-link');
    const $storePickerModal = $('#store-picker-modal');
    const $storePickerModalClose = $storePickerModal.find('button.modal-close');
    const $storePickerForm = $('#store-picker-form');
    const $storePickerSelect = $('#store-picker-select');
    const $storePickerSubmit = $storePickerForm.find(
      'button.store-picker-submit'
    );
    const $storePickerMenuLink = $storePickerForm.find(
      'a.store-picker-menu-link'
    );
    const $storePickerMessage = $storePickerModal.find('.store-picker-message');
    const outInventoryLevelAll = $storePickerModal.data(
      'out-inventory-level-all'
    );
    const outInventoryLevelOverride = $storePickerModal.data(
      'out-inventory-level-override'
    );
    const overrideCollection = $storePickerModal.data('override-collection');
    const $storePickerOnlineLinkContainer = $(
      '.store-picker-online-link-container'
    );
    const $storePickerOnlineLink = $('#store-picker-online-link');

    const showStoreInfo = (store) => {
      // hide info for all stores
      $storePickerForm.find('[id*="-info"]').hide();
      $storePickerForm.find('[id*="-address"]').hide();
      // show selected store info
      $storePickerForm.find(`#${store}-info`).show();
      $storePickerForm.find(`#${store}-address`).show();
    };

    const checkStoreInventory = async (store) => {
      const itemsToUpdate = {};

      const getProductVariantMeta = (item, store) => `
        {
          product: productByHandle(handle: "${item.handle}") {
            id
            title
            collections (first: 50) {
              edges {
                node {
                  handle
                }
              }
            }
            variant: variantBySelectedOptions(selectedOptions: [
              {name: "${item.options_with_values[0].name}", value: "${item.options_with_values[0].value}"}
            ]) {
              id
              title
              ${store}: metafield(namespace: "inv", key: "${store}") {
                inv: value
              }
            }
          }
        }
      `;

      await Promise.all(
        cart.items.map(async (item) => {
          try {
            const result = await fetch(`/api/graphql`, {
              method: 'post',
              headers: storefrontHeaders,
              body: `${getProductVariantMeta(item, store)}`,
            });

            const data = await result.json();
            const variantMeta = data.data.product.variant[store];

            if (!variantMeta) {
              // no inv metafield found for this store, set to zero
              itemsToUpdate[item.variant_id] = 0;
              return;
            }

            const productCollections = data.data.product.collections.edges;
            const inOverrideCollection = productCollections.some(
              ({ node: collection }) => collection.handle === overrideCollection
            );
            const invLimit = inOverrideCollection
              ? outInventoryLevelOverride
              : outInventoryLevelAll;
            const storeInv = Math.max(
              0,
              !isNaN(variantMeta.inv) && variantMeta.inv
            );
            const limitedStoreInv = Math.max(0, storeInv - invLimit);

            // use default out limit for "online" store
            if (store === 'online') {
              if (storeInv < item.quantity) {
                itemsToUpdate[item.variant_id] = storeInv;
              }
            } else {
              if (limitedStoreInv < item.quantity) {
                itemsToUpdate[item.variant_id] = limitedStoreInv;
              }
            }

            return;
          } catch (error) {
            console.error(error);
          }
        })
      );

      return itemsToUpdate;
    };

    const setLineItemProps = async (newStore) => {
      const cartChangeLineItem = async (item) => {
        const itemProps = item.properties || {};
        itemProps['store'] = newStore;

        try {
          const result = await $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: $.param({
              id: item.key,
              quantity: item.quantity,
              properties: itemProps,
            }),
            dataType: 'json',
          });
        } catch (error) {
          console.error(error);
        }

        return;
      };

      let itemIndex = 0;

      do {
        await cartChangeLineItem(cart.items[itemIndex]);
        itemIndex++;
      } while (itemIndex < cart.items.length);

      // refresh the cart
      cart = await getCart();
    };

    const selectStoreAndTriggerChange = (store) => {
      $storePickerSelect.val(store);
      // trigger change to show store info and run cart check
      $storePickerSelect.trigger('change');
    };

    const closeStorePickerModal = () => {
      $('body').removeClass('scroll-lock sp-modal-loading sp-modal-visible');
    };

    const enableStorePickerModalEscape = () => {
      // watch for escape key presses
      document.onkeydown = (evt) => {
        evt = evt || window.event;
        let isEscape = false;

        if ('key' in evt) {
          isEscape = evt.key === 'Escape' || evt.key === 'Esc';
        } else {
          isEscape = evt.keyCode === 27;
        }

        if (isEscape && $('body').hasClass('sp-modal-visible')) {
          closeStorePickerModal();
        }
      };

      // enable closing by clicking overlay
      $storePickerModal.on('click', (e) => {
        if (e.target === e.currentTarget) {
          e.preventDefault();
          closeStorePickerModal();
        }
      });

      // enable closing by clicking X button
      $storePickerModalClose.on('click', (e) => {
        e.preventDefault();
        closeStorePickerModal();
      });
    };

    const openStorePickerModal = async (storeFromLink) => {
      $('body').addClass('scroll-lock sp-modal-loading');
      // load cart again on modal open since this may not be on page load
      cart = await getCart();
      // get store saved in cart
      selectedStore = cart.attributes.store;

      if (selectedStore && validStores.includes(selectedStore)) {
        // allow for escaping modal without saving new store
        enableStorePickerModalEscape();
        // see if they clicked on select store link
        if (storeFromLink) {
          selectStoreAndTriggerChange(storeFromLink);
        } else {
          // update to show current selected store and info, without running cart check
          $storePickerSelect.val(selectedStore);

          if (selectedStore === 'online') {
            $storePickerOnlineLinkContainer.hide();
          } else {
            $storePickerOnlineLinkContainer.show();
          }

          showStoreInfo(selectedStore);
        }
      } else {
        if (savedStore && validStores.includes(savedStore)) {
          // use store saved in cookie
          selectStoreAndTriggerChange(savedStore);
        } else {
          // default to online store
          selectStoreAndTriggerChange('online');
        }
      }

      $('body').addClass('sp-modal-visible');
    };

    $storePickerMenuLink.on('click', async (e) => {
      const href = e.currentTarget.href;

      if (!selectedStore) {
        e.preventDefault();
        // set store to default of online
        Cookies.set('store_pref', 'online', { expires: 30 });
        // add store selection as cart attribute to be accessible by liquid
        try {
          cart = await $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: $.param({
              attributes: {
                store: 'online',
              },
            }),
            dataType: 'json',
          });
        } catch (error) {
          console.error(error);
        }

        // send user to link clicked
        location = href;
      }
    });

    $storePickerOnlineLink.on('click', (e) => {
      e.preventDefault();
      selectStoreAndTriggerChange('online');
    });

    $storePickerLink.on('click', (e) => {
      e.preventDefault();
      openStorePickerModal();
    });

    $selectStoreLink.on('click', (e) => {
      e.preventDefault();
      const storeFromLink = e.currentTarget.dataset.selectStore;
      openStorePickerModal(storeFromLink);
    });

    $storePickerSelect.on('change', async (e) => {
      $storePickerMessage.text('').hide();
      const newStore = $(e.currentTarget).val();

      if (newStore === 'online') {
        $storePickerOnlineLinkContainer.hide();
      } else {
        $storePickerOnlineLinkContainer.show();
      }

      showStoreInfo(newStore);

      // because select box includes in-store only locations, need to check for them before running cart check
      // can't get shop meta on front end, so parse for "In-store only"
      if (
        newStore === selectedStore ||
        $('#store-picker-select option:selected')
          .text()
          .includes('In-store only')
      ) {
        return;
      }

      // check to see if there are items in cart
      if (cart.item_count) {
        const itemsToUpdate = await checkStoreInventory(newStore);

        // warn user if any of the items have insufficient stock at new location
        if (Object.keys(itemsToUpdate).length > 0) {
          $storePickerMessage
            .text(
              'If you change stores, any products not available at the new store will be removed from your cart.'
            )
            .show();
        }
      }
    });

    $storePickerForm.on('submit', async (e) => {
      e.preventDefault();
      const newStore = $storePickerSelect.val();

      // just close modal when new store is the same as previously selected store
      if (selectedStore === newStore) {
        closeStorePickerModal();
        return;
      }

      if (cart.item_count) {
        // NOTE: update "store" line item properties before checking/updating line item quantites
        // (cart is refreshed inside that method)
        await setLineItemProps(newStore);

        const itemsToUpdate = await checkStoreInventory(newStore);

        if (Object.keys(itemsToUpdate).length > 0) {
          try {
            cart = await $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: $.param({ updates: itemsToUpdate }),
              dataType: 'json',
            });
          } catch (error) {
            console.error(error);
          }
        }
      }

      // set cookie with store selection
      Cookies.set('store_pref', newStore, { expires: 30 });

      // add store selection as cart attribute to be accessible by liquid
      try {
        cart = await $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: $.param({
            attributes: {
              store: newStore,
            },
          }),
          dataType: 'json',
        });
      } catch (error) {
        console.error(error);
      }

      // refresh the page to have any collections, current store, dynamic menu links, etc. get new store
      location.reload();
    });

    const getMatchedVariantId = (variantTitle, variants) => {
      const matchedVariant = variants.find(
        (variant) => variant.title === variantTitle
      );
      return matchedVariant.id;
    };

    const addVariantInventoryIndicators = () => {
      // get product blocks and json data
      // NOTE: number of elements returned varies if related product modals have been opened
      const $productBlocks = $('[id^="product-id"]');

      $productBlocks.each((idx, el) => {
        const $product = $(el);
        const $productQuickshopData = $product.siblings(
          '[data-product-quickshop-data]'
        );
        const $productPrimaryData = $product
          .parents('#shopify-section-static-product')
          .children('[data-section-id="static-product"]');

        // load product data
        const productData = $productQuickshopData.length
          ? JSON.parse($productQuickshopData.html())
          : JSON.parse($productPrimaryData.html());
        const productId = productData.product.id;
        const productVariants = productData.product.variants;

        // update inventory status on variant change
        const $variantSelector = $product.find('.form-options select');

        $variantSelector.on('change', (e) => {
          const selectedVariantTitle = $(e.currentTarget).val();
          const variantId = getMatchedVariantId(
            selectedVariantTitle,
            productVariants
          );
          const $allInventoryIndicators = $product.find('.variant-inventory');
          $allInventoryIndicators.hide();
          const $variantInventoryIndicators = $product.find(
            `.variant-inventory[data-variant=${variantId}]`
          );
          $variantInventoryIndicators.show();
        });
      });
    };

    // on page load
    addVariantInventoryIndicators();
    initSelectStore();

    // watch for product modals opening (e.g. Quick Shop)
    // NOTE: using mutation observer because modal content does not exist in DOM on page load
    const modalObserver = new MutationObserver((mutations) => {
      const target = mutations[0].target;

      if (target.attributes['data-product-quickshop']) {
        addVariantInventoryIndicators();
      }
    });

    modalObserver.observe(document, {
      subtree: true,
      attributeFilter: ['data-loaded'],
    });

    // watch for age gate modal closing
    const ageGateObserver = new MutationObserver((mutations) => {
      const isClosed = mutations.some(
        (mutation) => mutation.target.style.display === 'none'
      );

      if (isClosed) {
        initSelectStore();
      }
    });

    ageGateObserver.observe(
      document.querySelector('.age-verification-overlay'),
      {
        attributeFilter: ['style'],
      }
    );
  })();
});
